import { environment } from "../../../environments/environment";
import { ProgressStatuses } from "../../tasks-wizard/models/progress-statuses";

export class ProfileInfo {
    public id: string;
    public accountId: string;
    public resumeId: string;
    public name: string;
    public photoPath: string;
    public title: string;
    public progressStatus: string;

    public static parse(jsonData: any): ProfileInfo {
        let profile = new ProfileInfo();
        profile = Object.assign(profile, jsonData);
        profile.photoPath = `${environment.baseUrl}/${profile.photoPath}`;
        if(profile.progressStatus) {
            profile.progressStatus = ProgressStatuses[profile.progressStatus];
        }
        
        return profile;
    }
}
